<template>
  <div class="approvalApply">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.sourceCsUserName" placeholder="代理名称" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="request.state" placeholder="申请状态" style="width:150px">
            <el-option v-for="item in global.apply_state" :key="item.code" :label="item.message" :value="item.code" clearable></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="request.type" placeholder="申请类型" style="width:150px" clearable>
            <el-option v-for="item in global.apply_type" :key="item.code" :label="item.message" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getCsApply">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="787" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="申请类型" align="center" prop="typeStr"></el-table-column>
        <el-table-column label="代理名称" align="center" prop="sourceCsUserName"></el-table-column>
        <el-table-column label="代理电话" align="center" prop="sourceCsUserPhone"></el-table-column>
        <el-table-column label="申请数量" align="center" prop="num"></el-table-column>
        <el-table-column label="发货仓库" align="center" prop="targetWarehouseId"></el-table-column>
        <el-table-column label="申请时间" align="center" prop="createTime"></el-table-column>
        <el-table-column label="操作人" align="center" prop="operationPerson"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope"><el-tag type="success">{{ scope.row.stateStr }}</el-tag></template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope"><el-button type="warning" size="small" plain @click="applyDetail(scope.row)">详情</el-button></template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
      <apply-detail v-if="applyDetailDialog" ref="applyDetail" @approval-succeed="approvalSucceed"></apply-detail>
    </div>
  </div>
</template>
<script>
import {getAllCsDeviceApply, approvalApply, refuse, revoke} from '../../../api/apply/approvalapply.js';
import ApplyDetail from './applydetail.vue'
export default {
  name: 'approvalApply',
  components: {ApplyDetail},
  data() {
    return {
      request: {
        sourceCsUserName: '',
        type: '',
        state: '',
        current: '',
        size: ''
      },
      query: {current: 1, size: 15},
      response: {data: [], total: 0},
      global: '',
      loading: false,
      applyDetailDialog: false
    }
  },
  methods: {
    /**
     * 获取申请列表
     */
    getCsApply() {
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getAllCsDeviceApply(this.request).then(result => {
        this.response.total = result.data.total;
        this.response.data = result.data.records;
      })
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getCsApply();
    },

    /**
     * 重置
     */
    reset(){
      this.request.sourceCsUserName = "";
      this.request.type = "";
      this.request.state = "";
      this.query.current = 1;
      this.getCsApply();
    },

    /**
     * 申请详情
     */
    applyDetail(item){
      this.applyDetailDialog = true;
      this.$nextTick(() => {
        this.$refs.applyDetail.init(item);
      })
    },

    /**
     * 审核成功，重新请求
     */
    approvalSucceed(){
      this.applyDetailDialog = false;
      this.getCsApply();
    }
  },
  created() {
    this.global = JSON.parse(sessionStorage.getItem("global"));
    this.getCsApply()
  }

}
</script>

<style scoped>
.approvalApply {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/warehouse/apply/approvalapply.vue